import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class AssignReportService {


  constructor(private _http: HttpClient) {}

  getAssignTE(page): Observable<any> {
    const httpParams = new HttpParams({
      fromObject: page
    });
    return this._http.get<any>(`${environment.BACKEND}asignacionTE/reporte/asigList`, {
      params: httpParams
    });
  }

  downloadCSV(page): Observable<any> {
    const httpParams = new HttpParams({
      fromObject: page
    });
    return this._http.get(`${environment.BACKEND}asignacionTE/reporte/asigCsv`, {
      params: httpParams
    });
  }

  getErrorList(page): Observable<any> {
    const httpParams = new HttpParams({
      fromObject: page
    });
    return this._http.get(`${environment.BACKEND}asignacionTE/reporte/errorList`, {
      params: httpParams
    });
  }

  downloadErrorCSV(page): Observable<any> {
    const httpParams = new HttpParams({
      fromObject: page
    });
    return this._http.get(`${environment.BACKEND}asignacionTE/reporte/errorListCsv`, {
      params: httpParams
    });
  }
}
